export { localize } from './Localize';
export { Translate } from './Translate';

export { localeReducer, initialize, addTranslation, addTranslationForLanguage, setLanguages, setActiveLanguage, getTranslate, getActiveLanguage, getLanguages, getTranslations, getOptions } from './locale';


//////////////////
// WEBPACK FOOTER
// ./~/react-localize-redux/es/index.js
// module id = 5
// module chunks = 4